import { useEffect, useState } from "react";
import { ArrowUpToLine, X } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

export function BumpModal({ listingId, onClose }) {
  const [pkg, setPkg] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/bump/package").then(({ data }) => setPkg(data));
  }, []);

  const close = () => { if (!busy) onClose(); };

  const startCheckout = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/listings/${listingId}/bump`, { origin_url: window.location.origin });
      window.location.href = data.url;
    } catch (e) {
      toast.error("Could not start checkout: " + (e.response?.data?.detail || e.message));
      setBusy(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4" data-testid="bump-modal" onClick={close}>
      <div className="bg-white border-2 border-black hard-shadow max-w-[480px] w-full" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between border-b-2 border-black p-4">
          <h3 className="font-display text-2xl uppercase flex items-center gap-2"><ArrowUpToLine size={20} className="text-[#0000EE]" /> Bump to Top</h3>
          <button data-testid="bump-modal-close" onClick={close} className="border-2 border-black p-1 hover:bg-black hover:text-white"><X size={14} /></button>
        </div>
        <div className="p-5 space-y-3">
          <p className="font-mono-data text-xs uppercase text-gray-700">Move your ad back to the top of the list right now and restart its 30-day clock.</p>
          <button
            data-testid="bump-checkout-btn"
            disabled={busy || !pkg}
            onClick={startCheckout}
            className="w-full border-2 border-black p-4 text-left hover:bg-yellow-100 disabled:opacity-50 flex items-center justify-between"
          >
            <div>
              <div className="font-display text-xl uppercase">{pkg?.label || "Bump to top"}</div>
              <div className="font-mono-data text-xs uppercase text-gray-600">top of list · fresh 30 days</div>
            </div>
            <div className="font-mono-data text-3xl font-bold" data-testid="bump-price">${pkg ? pkg.amount.toFixed(2) : "—"}</div>
          </button>
          <p className="font-mono-data text-[10px] uppercase text-gray-500">Secure checkout via Stripe. Test mode — use card 4242 4242 4242 4242.</p>
        </div>
      </div>
    </div>
  );
}
